import { LitElement, html, css } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { LIT_CSS_VARIABLES } from '@Root/lib/lit-styles.js';
import { SHARED_ELEMENTS, SHARED_CLASSES } from '../../styles';
import { DIALOG_STYLES } from '../../../lit-styles';

class DialogModal extends LitElement {
  static get properties() {
    return {
      content: { type: Object },
      _currentDialogId: { type: String },
    };
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      DIALOG_STYLES,
      css`
        .order-sheet-dialog {
          max-width: 80vw;
          max-height: 80vh;
        }

        .close-btn {
          font-size: calc(20em / var(--default-rem-px-count));
        }

        @media (min-width: 1024px) {
          .order-sheet-dialog {
            max-width: 800px;
          }
        }
      `,
    ];
  }

  constructor() {
    super();
    this.content = JSON.parse(this.getAttribute('content'));
    this._currentDialogId = '';
    this.outSideClickEventHandler = this.outSideClickEventHandler.bind(this);

    document.addEventListener('closeDialogModal', e => {
      this.closeCurrentDialog();
    });
    document.addEventListener('openOrderSheetDialog', e => {
      this.openDialog('order-sheet');
    });
  }

  async connectedCallback() {
    super.connectedCallback();
  }

  render() {
    return html`
      <dialog
        id=${this.dialogId}
        class=${classMap({
          'order-sheet-dialog': true,
        })}
      >
        <div id="dialog-content">
          <div class="dialog-header">
            <h3>${this.headerStr}</h3>
            <span class="close-btn" @click="${this.closeCurrentDialog}"
              >&#x2715;</span
            >
          </div>
          <div class="dialog-body">
            ${this.modalBodyHTML}
          </div>
        </div>
      </dialog>
    `;
  }

  get modalBodyHTML() {
    switch (this.dialogId) {
      case 'order-sheet':
        return html`
          <order-sheet-barrel
            content=${JSON.stringify(this.content)}
            id=${this.dialogId}
          ></order-sheet-barrel>
        `;
      default:
        html``;
    }
  }

  openDialog(id) {
    const dialog = this.shadowRoot.getElementById(id);
    if (dialog && !dialog.open) {
      // toggling inert prevents auto focus of the dialog's first clickable element
      dialog.inert = true;
      dialog.showModal();
      dialog.inert = false;
      this._currentDialogId = id;
      this.createClickOutsideHandler();
    }
  }

  createClickOutsideHandler() {
    if (this.dialogElement.open) {
      setTimeout(() => {
        document.addEventListener('click', this.outSideClickEventHandler);
      }, 500);
    }
  }

  outSideClickEventHandler(event) {
    const path = event.composedPath();
    if (path.some(el => el.id === 'dialog-content')) {
      return;
    } else {
      this.closeCurrentDialog();
    }
  }

  closeCurrentDialog() {
    if (this._currentDialogId) {
      const dialog = this.shadowRoot.getElementById(this._currentDialogId);
      if (dialog) {
        document.removeEventListener('click', this.outSideClickEventHandler);
        this._currentDialogId = '';
        dialog.close();
      }
    }
  }

  get dialogElement() {
    return this.shadowRoot.getElementById(this._currentDialogId) || null;
  }

  get parsedContent() {
    if (this.content) return this.content;

    this.content = this.getAttribute('content')
      ? JSON.parse(this.getAttribute('content'))
      : null;

    return this.content;
  }

  get headerStr() {
    return this.content.headerStr || '';
  }

  get dialogId() {
    return this.content.dialogId;
  }
}
customElements.define('dialog-modal', DialogModal);
